import { render } from "./SzNodata.vue?vue&type=template&id=53472c63&scoped=true"
const script = {}

import "./SzNodata.vue?vue&type=style&index=0&id=53472c63&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-53472c63"

export default script